<p>{{ isOffline ? "Offline" : "Online" }}</p>
<p>Morralla : {{ morrallaCount }}</p>
<p>Botones Rapidos : {{ btnRapidoCount }}</p>
